import { render } from "./Banks.vue?vue&type=template&id=10f6b233&scoped=true"
import script from "./Banks.vue?vue&type=script&lang=js"
export * from "./Banks.vue?vue&type=script&lang=js"

import "./Banks.vue?vue&type=style&index=0&id=10f6b233&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10f6b233"]])

export default __exports__